import { render } from "./HandleIcon.vue?vue&type=template&id=3b86a698"
const script = {}
script.render = render

export default script